import { createGlobalStyle } from 'styled-components';
import typography from './typography';

const GlobalTypographyStyles = createGlobalStyle`
  :root {
    --aidose-font-family: ${typography.family};
    --aidose-font-body: ${typography.body};
    --aidose-font-helper: ${typography.helper};
    --aidose-font-section: ${typography.section};
    --aidose-font-page: ${typography.page};
  }
  body {
    font-family: ${typography.family};
    font-size: ${typography.body};
    line-height: ${typography.lineHeight};
  }
  h1, h2, h3, h4, h5, h6, p,
  input, textarea, select, button,
  .ant-typography, .ant-table, .ant-form, .ant-menu, .ant-card,
  .ant-modal, .ant-drawer, .ant-select, .ant-picker, .ant-tabs,
  .ant-tooltip, .ant-popover, .ant-message, .ant-notification {
    font-family: ${typography.family};
  }
  .ant-input, .ant-input-affix-wrapper, .ant-input-number-input,
  .ant-select-selection-item, .ant-select-selection-placeholder,
  .ant-select-item, .ant-picker-input > input, .ant-btn,
  .ant-form-item-label > label, .ant-table-thead > tr > th,
  .ant-table-tbody > tr > td, .ant-menu-item, .ant-menu-submenu-title,
  .ant-tabs-tab, .card-nav ul li a, .ant-pagination-item a {
    font-size: ${typography.body} !important;
  }
  .ant-tabs-tab, .ant-tabs-tab .ant-tabs-tab-btn,
  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    font-weight: 400;
    text-shadow: none;
  }
  .ant-tabs-top > .ant-tabs-nav::before {
    border-bottom-color: ${({ theme }) => theme['border-color-light']};
  }
  .ant-tabs-top > .ant-tabs-nav .ant-tabs-ink-bar {
    height: 2px;
  }
  .ant-form-item-label > label { font-weight: 500; }
  .ant-table-wrapper .ant-table-thead > tr > th {
    font-family: ${typography.family} !important;
    font-size: ${typography.body} !important;
    font-weight: 400 !important;
    letter-spacing: normal;
  }
  .ant-card-head-title, .ant-modal-title, .ant-drawer-title {
    font-size: ${typography.section};
    font-weight: 600;
    line-height: ${typography.lineHeight};
  }
  .ant-page-header-heading-title {
    font-size: ${typography.page} !important;
    font-weight: 600;
    line-height: ${typography.lineHeight};
  }
  .ant-form-item-explain, .ant-form-item-extra, .ant-typography small {
    font-size: ${typography.helper};
    line-height: ${typography.lineHeight};
  }
`;
export default GlobalTypographyStyles;
